/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Copilot_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not change copilot." |
*
* @param {Partner_Manage_Copilot_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_copilot_error = /** @type {((inputs?: Partner_Manage_Copilot_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Copilot_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Copilot konnte nicht geändert werden.")
	return /** @type {LocalizedString} */ ("Could not change copilot.")
});